const API_URL = process.env.REACT_APP_API_URL;

export async function analyzeWaste(imageBase64) {
  try {
    const res = await fetch(`${API_URL}/api/analyze`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        image: `data:image/jpeg;base64,${imageBase64}`,
      }),
    });

    if (!res.ok) {
      throw new Error(`Server error: ${res.status}`);
    }

    const data = await res.json(); // data là object {LoaiRac, Buoc1, Buoc2, Buoc3}
    
    // Nếu API trả về lỗi trong object
    if (data.error) {
      throw new Error(data.error);
    }

    return data; // trả về object JSON trực tiếp
  } catch (err) {
    console.error(err);
    return { error: err.message }; // trả về object error để ResultBox xử lý
  }
}

